import { createIcon } from "@chakra-ui/react";

export const DownloadFolder = createIcon({
  displayName: "DownloadFolder",
  viewBox: "0 0 24 24",
  d: "M11.798 5.481a2.621 2.621 0 0 0 1.857.769H21c.413 0 .75.338.75.75v12c0 .413-.337.75-.75.75H3a.752.752 0 0 1-.75-.75V4c0-.413.337-.75.75-.75h6.258c.197 0 .389.08.53.22l2.01 2.011zm1.59-1.589-2.011-2.015A3.001 3.001 0 0 0 9.253 1H3C1.345 1 0 2.345 0 4v15c0 1.655 1.345 3 3 3h18c1.655 0 3-1.345 3-3V7c0-1.655-1.345-3-3-3h-7.345a.38.38 0 0 1-.268-.108zm-.263 4.983c0-.623-.502-1.125-1.125-1.125s-1.125.502-1.125 1.125v4.786l-1.453-1.453a1.125 1.125 0 0 0-1.59 1.59l3.376 3.374c.44.44 1.153.44 1.589 0l3.375-3.375a1.125 1.125 0 0 0-1.59-1.59l-1.452 1.454V8.875h-.005z",
  defaultProps: {
    "aria-label": "Download icon: An arrow pointing down within a folder"
  }
});

export default DownloadFolder;
